import React, { useCallback } from 'react';
import { Product } from '../types';
import { useCart } from '../context/cart-context';
import { useToaster } from '../context/toaster-context';

export const useCartActions = () => {
  const { addToCart, removeFromCart, updateQuantity } = useCart();
  const { showToaster } = useToaster();

  const handleAddToCart = useCallback((product: Product) => {
    addToCart({...product, productImages: [], inventories: [], image: '', category: { ...product.category, avatarBase64: ''}});
    showToaster("Cart notification", product);
  },[]);

  const handleRemoveFromCart = useCallback((productId: number) => {
    removeFromCart(productId);
  }, []);

  const handleQuantityChange = useCallback((productId: number, newQuantity: number) => {
    updateQuantity(productId, newQuantity);
  }, []);

  return {
    handleAddToCart,
    handleRemoveFromCart,
    handleQuantityChange
  };
};